import { Suspense } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import RootUserLayout from "../layout";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { contactsQueryOptions } from "../service/contact";
import { ContactsTable } from "./components/contacts-table";

function ContactsContent() {
  const { data: contacts } = useSuspenseQuery(contactsQueryOptions);

  return <ContactsTable contacts={contacts} />;
}

export default function Contacts() {
  return (
    <RootUserLayout
      pageTitle="Contacts"
      pageDescription="Customer contacts list (Salesflare)"
    >
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Contacts..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <ContactsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}
